import Axios from 'axios';
import { tsvParse as d3TsvParse } from 'd3-dsv';


const LOAD_START = 'ProductionVis/VisState/LOAD_START';
const LOAD_SUCCESS = 'ProductionVis/VisState/LOAD_SUCCESS';
const LOAD_ERROR = 'ProductionVis/VisState/LOAD_ERROR';


const initialState = {
  loading: true,
  data: false
}

export function loadData() {
  return dispatch => {
    dispatch({ type: LOAD_START });

    Axios.get(`data/production.csv`)
      .then(res => {
        let data = d3TsvParse(res.data);
        data = parseData(data);
        dispatch({ type: LOAD_SUCCESS, data });
      })
      .catch(err => dispatch({ type: LOAD_ERROR }));
    }
}

function parseData(data) {
  const YEARS = [1990, 1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999, 2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014];

  const res = [];
  data.forEach(d => {
    for(let i = 0; i < YEARS.length; i++) {
      const y = YEARS[i];
      res.push({ country: d.Land, date: y, areaValue: d[`${y}_Anbauflaeche`], rawProdValue: d[`${y}_Rohkaffee`], rank: d[`${y}_Rang`] });
    }
  });
  return res;
}

export default function AppReducer(state = initialState, action = {}) {
  switch(action.type) {
    case LOAD_START:
     return Object.assign({}, state, { loading: true });

    case LOAD_SUCCESS:
     return Object.assign({}, state, {
       loading: false,
       data: action.data
     });

    default:
      return Object.assign({}, state)
  }
};



// WEBPACK FOOTER //
// ./src/modules/ProductionVis/VisState.js